// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Newsletter_newsletter__BXPWm {
  padding: 2.5rem 0;
}

.Newsletter_grid__p5tSj {
  display: grid;
  gap: 1.25rem;
  grid-template-columns: 1fr;
  align-items: center;
}
@media (min-width: 768px) {
  .Newsletter_grid__p5tSj {
    grid-template-columns: 1fr 1fr;
  }
}

.Newsletter_button__BDr\\+n {
  background-color: var(--color-naranja) !important;
}

.Newsletter_text__7dmPf h6 {
  margin-bottom: 0.5rem;
  font-weight: 700;
  color: var(--color-secundario);
}
.Newsletter_text__7dmPf p {
  margin: 0;
  color: var(--color-secundario);
  font-size: 0.9rem;
}

.Newsletter_form__R0eon {
  display: flex;
  gap: 0.5rem;
}

@media (max-width: 576px) {
  .Newsletter_newsletter__BXPWm {
    padding: 1rem;
  }
  .Newsletter_form__R0eon {
    flex-direction: column;
  }
  .Newsletter_text__7dmPf p {
    font-size: var(--font-normal);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Newsletter/Newsletter.module.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;AACJ;AACI;EANJ;IAOQ,8BAAA;EAEN;AACF;;AACA;EACI,iDAAA;AAEJ;;AAEI;EACI,qBAAA;EACA,gBAAA;EACA,8BAAA;AACR;AAEI;EACI,SAAA;EACA,8BAAA;EACA,iBAAA;AAAR;;AAIA;EACI,aAAA;EACA,WAAA;AADJ;;AAKA;EACI;IACI,aAAA;EAFN;EAKE;IACI,sBAAA;EAHN;EAOM;IACI,6BAAA;EALV;AACF","sourcesContent":[".newsletter {\n    padding: 2.5rem 0;\n}\n\n.grid {\n    display: grid;\n    gap: 1.25rem;\n    grid-template-columns: 1fr;\n    align-items: center;\n\n    @media (min-width: 768px) {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n.button {\n    background-color: var(--color-naranja) !important;\n}\n\n.text {\n    h6 {\n        margin-bottom: 0.5rem;\n        font-weight: 700;\n        color: var(--color-secundario);\n    }\n\n    p {\n        margin: 0;\n        color: var(--color-secundario);\n        font-size: 0.9rem\n    }\n}\n\n.form {\n    display: flex;\n    gap: 0.5rem;\n\n}\n\n@media (max-width: 576px) {\n    .newsletter {\n        padding: 1rem;\n    }\n\n    .form {\n        flex-direction: column;\n    }\n\n    .text {\n        p {\n            font-size: var(--font-normal);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newsletter": `Newsletter_newsletter__BXPWm`,
	"grid": `Newsletter_grid__p5tSj`,
	"button": `Newsletter_button__BDr+n`,
	"text": `Newsletter_text__7dmPf`,
	"form": `Newsletter_form__R0eon`
};
export default ___CSS_LOADER_EXPORT___;
